import { Component, OnInit, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { FarmApiService } from 'src/app/core/api/farm-api.service';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { IFarmModel } from 'src/app/core/models/interfaces/farm-model';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { SprayingResponse } from '../../../pesttrapp/models/spraying.response';
import { SprayingService } from '../../services/spraying.service';
import { AddSprayingComponent } from '../add-spraying/add-spraying.component';
import { SprayingHoursComponent } from '../spraying-hours/spraying-hours.component';
import { IonPopover } from '@ionic/angular';

@Component({
  selector: 'app-spraying',
  templateUrl: './spraying.component.html',
  styleUrls: ['./spraying.component.scss'],
})
export class SprayingComponent implements OnInit {
  sprayingList: Array<SprayingResponse> = [];
  farmId: number;
  farm: IFarmModel
  querySubs: Subscription;
  type: string
  databaseError: boolean = false;
  loading: boolean = true;
  @ViewChildren(IonPopover) popovers : any;
  constructor(
    private sprayingService: SprayingService,
    private activatedRoute: ActivatedRoute,
    private modalService: ModalService,
    private loadingService: LoadingService,
    private farmApiService: FarmApiService,
    private storageService: StorageService) { }

  ngOnInit() { }

  ionViewDidEnter() {
    this.storageService.get(StorageKeys.FILIZ_MODE).then(e => {
      if (e.IsSuccess) {
        if (e.Data) {
          this.type = "filiz"
        } else {
          this.type = "trap"
        }
        this.farm = this.farmApiService.getLastFarm(this.type);
      }
    })
    this.querySubs = this.activatedRoute.queryParams.subscribe(e => {
      if (e["farmId"]) {
        this.farmId = +e["farmId"];
        this.getList();
      }
    });
  }

  ionViewDidLeave() {
    if (typeof this.querySubs != "undefined") {
      this.querySubs.unsubscribe();
    }
  }

  viewHours() {
    this.modalService.presentModal({
      component: SprayingHoursComponent,
      componentProps: {
        farm: this.farm
      },
      options: ModalService.defaultOptionsTransparent,
    });
  }

  getList() {
    this.loading = true;
    this.sprayingList = [];
    this.loadingService.showLoading();
    this.sprayingService.getSprayingList(this.farmId).subscribe(res => {
      this.loadingService.hideLoading();
      this.loading = false;
      if (res.IsSuccess) {
        this.databaseError = false;
        this.sprayingList = res.Data;
      } else {
        this.databaseError = true;
      }
    }, err => {
      this.loading = false;
      this.loadingService.hideLoading();
      this.databaseError = true;
    });
  }
  deleteItem(id) {
    this.loadingService.showLoading();
    this.sprayingService.deleteSpraying(id).subscribe(data => {
      this.getList();
      if (this.popovers?.length) {
        this.popovers.forEach(popover => {
          popover.dismiss()
        });
      }
      this.loadingService.hideLoading();
    })
  }
  save(item?: SprayingResponse) {
    let modalId = Date.now();
    this.modalService.presentModal({
      component: AddSprayingComponent,
      id: modalId,
      componentProps: {
        tempFarmAttrId: this.farmId,
        date: item?.Date,
        chemicalId: item?.ChemicalTypeId,
        sprayingId: item ? item.Id : 0
      },
      options: {
        cssClass: "center-modal"
      }
    }).then(modal => {
      modal.modalObj.onDidDismiss().then(res => {
        if (res.role == "success") {
          this.getList();
          if (this.popovers?.length) {
            this.popovers.forEach(popover => {
              popover.dismiss()
            });
          }
          this.storageService.lastFilizFarmId = null;
          this.storageService.lastTrapFarmId = null;
        }
      });
    });
  }
  enterDate() { }


}
